import React from "react";
import { ClickEventType, ParlorDetailProps } from "../../../types";
import { Box, Stack } from "@mui/material";
import { FullWidthButton } from "../../common/Buttons/FullWidthButton";
import { Image } from "../../common/Image";
import { getCdnImageSrc } from "../../../utils";
import {
  ColorSystemProps,
  GOI_WEB_URL,
  FLOWER_IMAGES,
} from "../../../constants";

export function BTypeFlowerSummary({
  defaultParlor,
  mainColor,
  event,
}: {
  defaultParlor: ParlorDetailProps;
  mainColor: ColorSystemProps;
  event?: ClickEventType;
}) {
  return (
    <Stack alignItems="center" gap="16px">
      <Box className="subtitle_18_sb" component="h3">
        근조화환 보내기
      </Box>
      <Stack flexDirection="row" justifyContent="space-between">
        <Stack className="body_14_m" alignItems="center" gap="8px">
          <Box style={{ background: "white" }}>
            <Image
              src={getCdnImageSrc(FLOWER_IMAGES.NORMAL)}
              width="110px"
              alt=""
            />
          </Box>
        </Stack>
        <Stack className="body_14_m" alignItems="center" gap="8px">
          <Box style={{ background: "white" }}>
            <Image
              src={getCdnImageSrc(FLOWER_IMAGES.LUXURY)}
              width="110px"
              alt=""
            />
          </Box>
        </Stack>
        <Stack className="body_14_m" alignItems="center" gap="8px">
          <Box style={{ background: "white" }}>
            <Image
              src={getCdnImageSrc(FLOWER_IMAGES.LARGE)}
              width="110px"
              alt=""
            />
          </Box>
        </Stack>
      </Stack>
      <Stack component="p" textAlign="center" className="subtitle_14_sb">
        주문시 2시간 이내 배송되며,
        <br />
        배송 완료 후 신청하신 번호로 확인 사진 보내드립니다.
        <br />- 고이장례연구소 -
      </Stack>
      <Stack padding="0 20px" width="100%">
        <FullWidthButton
          text="근조화환 주문하러 가기"
          href={`${GOI_WEB_URL}/parlor/${defaultParlor.id}/?showFlowerModal=true&utm_source=dogsound`}
          backgroundColor={mainColor.c400}
          event={event}
        />
      </Stack>
    </Stack>
  );
}
